<template>
  <main>

    <div class="path">
      <i class="el-icon-caret-right"></i>客户管理
      <i class="el-icon-arrow-right"></i>&nbsp;订单列表
    </div>

    <br>
    <div class="content_wrapper">
      <el-form label-width="120px">
        <div class="item-wrapper">
          <el-form-item label="客户名称" style="margin-bottom: 0px;">
            <el-input v-model="cusName" type="text" clearable
                      style="width: 320px">
              <el-button slot="append" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <section class="content_wrapper">
      <el-table
        :data="tableData.list"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ (currentPage-1) * pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          prop="cusName"
          label="客户名称"
          width="230">
        </el-table-column>

        <el-table-column
          prop="orderNo"
          label="订单编号"
          width="160">
        </el-table-column>

        <el-table-column
          prop="aliOrderId"
          label="阿里订单编号"
          width="170">
        </el-table-column>

        <el-table-column
          prop=""
          label="订单价格（元）"
          width="120">
          <template slot-scope="scope">
            {{formattedPrice(scope.row.realPrice/100)}}
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="下单时间"
          width="170">
        </el-table-column>

        <el-table-column
          prop=""
          label="支付状态"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.payStatus === 1" type="success" disable-transitions>已支付</el-tag>
            <el-tag v-else type="danger" disable-transitions>未支付</el-tag>
          </template>
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="payedTime"-->
<!--          label="支付时间"-->
<!--          width="170">-->
<!--        </el-table-column>-->

        <el-table-column
          prop=""
          label="发票状态"
          width="110">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.invoiceStatus === 9" type="success" disable-transitions>已开票</el-tag>
            <el-tag v-if="scope.row.invoiceStatus === 1" type="danger" disable-transitions>已申请开票</el-tag>
            <el-tag v-if="scope.row.payStatus === 1 && scope.row.invoiceStatus === 0" disable-transitions>未开票</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="openDialog(scope.row)" type="text" size="small">详情</el-button>
          </template>
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="invoiceTime"-->
<!--          label="开票时间">-->
<!--        </el-table-column>-->

      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>


      <el-dialog v-if="orderDetail.id" title="订单详情" :visible.sync="dialogVisible" width="64%">
        <div class="desc_box">
          <div class="desc_section">
            <span class="desc_item">
              <span class="desc_item_label">订单编号:</span>
              <span class="desc_item_value">{{orderDetail.orderNo}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">产品编号:</span>
              <span class="desc_item_value">{{orderDetail.productKey}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">购买类型:</span>
              <span class="desc_item_value">{{orderDetail.purchaseType == 1 ? '新购' : orderDetail.purchaseType == 2 ? '续购' : '升级'}}</span>
            </span>
          </div>

          <div class="desc_section">
            <span class="desc_item">
              <span class="desc_item_label">Token数量（万个）:</span>
              <span class="desc_item_value">{{orderDetail.tokenNumber}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">访问并发（QPS/s）:</span>
              <span class="desc_item_value">{{orderDetail.qps}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">有效时长（月）:</span>
              <span class="desc_item_value">{{orderDetail.duration}}</span>
            </span>
          </div>

          <div class="desc_section">
            <span class="desc_item">
              <span class="desc_item_label">license数量（个）:</span>
              <span class="desc_item_value">{{orderDetail.licenseCount}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">单价（元/license）:</span>
              <span class="desc_item_value">{{formattedPrice(orderDetail.unitPrice/100)}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">结算金额（元）:</span>
              <span class="desc_item_value">{{formattedPrice(orderDetail.settlementAmount/100)}}</span>
            </span>
          </div>

          <div v-if="orderDetail.purchaseType === 2" class="desc_section">
            <span class="desc_item">
              <span class="desc_item_label">升级前的token数量:</span>
              <span class="desc_item_value">{{orderDetail.lastTokenNumber}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">升级的单价（元/license）:</span>
              <span class="desc_item_value">{{formattedPrice(orderDetail.upgradeUnitPrice/100)}}</span>
            </span>
            <span class="desc_item">
              <span class="desc_item_label">剩余有效月份:</span>
              <span class="desc_item_value">{{formattedPrice(orderDetail.remainMonths)}}</span>
            </span>
          </div>

          <div class="desc_section">
            <span style="width: 100%;">
              <span class="desc_item_label">备注:</span>
              <span>{{orderDetail.note}}</span>
            </span>

          </div>
        </div>


        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </section>

  </main>
</template>

<style>
  .el-table .success-cell {
    background: #F0F9EB;
    font-weight: bold;
  }
</style>

<script>
import {
  reqFindAllOrders,
  reqOrderDetail
} from '@/api'

export default {
  name: 'AllOrders',

  data() {
    return {
      tableData: {},
      loading: true,
      cusName: '',
      dialogVisible: false,
      orderDetail: {},
      currentPage: 1,
      total: 0,
      pageSize: 15
    }
  },

  async mounted () {
    await this.findAllOrders()
  },

  methods: {
    async findAllOrders() {
      this.loading = true
      const result = await reqFindAllOrders(this.cusName, this.currentPage)
      if (result.code === 0) {
        this.tableData = result.data
        this.loading = false
        this.total  = result.data.total
        this.pageSize  = result.data.pageSize
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async openDialog(row) {
      const result = await reqOrderDetail(row.id)
      if (result.code === 0) {
        this.orderDetail = result.data
        this.dialogVisible = true
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async handleCurrentChange(val) {
      this.currentPage = val
      await this.findAllOrders()
    },

    handleQuery () {
      this.tableData = {}
      this.handleCurrentChange(1)
    },

    formattedPrice (price) {
      return parseFloat(price).toFixed(2); // 保留两位小数
    },
  },

  computed: {
  }

}
</script>

<style scoped>

  main {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .content_wrapper {
    width: 82vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px auto;
  }

  .search_bar {
    width: 800px;
    margin: 20px auto;
  }

  .search_result_tip {
    color: #909399;
    font-size: 14px;
    line-height: 50px;
  }

  .btn {
    width: 140px;
    margin: 20px auto;
  }

  .path {
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    font-size: 14px;
    color: #666;
  }

  .desc_box {
    display: flex;
    flex-direction: column;
  }

  .desc_section {
    margin-bottom: 10px;
  }

  .desc_item {
    width: 340px;
  }

  .desc_item_label {
    width: 180px;
    text-align: right;
    margin-right: 4px;
  }
  .desc_item_value {
    width: 150px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AdminCenter/AllOrders/AllOrders.vue